import React, { useEffect, useState } from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../../../template/MainTheme/components/Breadcrumbs';
import { Tabs, Tab } from 'react-bootstrap';
import QuoteTab from '../tabs/QuoteTab';
import QuoteRouteSegmentsContainer from '../QuoteRouteSegmentsContainer';
import QuoteDetailsShowContainer from '../QuoteDetailShowContainer';
import { QuoteShowDataForm } from '../../../../app/models/Quote';
import { QuoteRouteSegment } from '../../../../app/models/QuoteRouteSegment';
import DefaultCard from '../../../../components/default/DefaultCard';
import { QuoteInvoicingShowDataForm } from '../../../../app/models/QuoteInvoicing';
import useQuoteInvoicingService from '../../../../app/services/hooks/useQuoteInvoicingService';
import QuoteInvoicingShowForm from '../forms/QuoteInvoicingShowForm';
import LazyLoading from '../../../../components/LazyLoading';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useQuoteService from '../../../../app/services/hooks/useQuoteService';

interface Props {
    id: number;
    quoteForm: QuoteShowDataForm;
    quoteRouteSegments: QuoteRouteSegment[];
    quoteCheckDocument: boolean;
    fetchingQuote: boolean;
    setQuoteRouteSegments: (segments: QuoteRouteSegment[]) => void;
}

const QuoteShowContainer = ({
    id,
    quoteForm,
    quoteRouteSegments,
    quoteCheckDocument,
    fetchingQuote,
    
    setQuoteRouteSegments
}: Props) => {

    const { 
        getQuoteInvoicingByQuote,
        updateQuoteInvoicing, 
        fetchingQuoteInvoicingByQuote,
        fetchingUpdateQuoteInvoicing
    } = useQuoteInvoicingService();

    const { showQuote, fetchingShowQuote } = useQuoteService()
    useEffect(() => {
        // show(id);
        reloadQuoteInvoicing(id)
    }, [id]);


    // const show = (id: number) => {
    //     showQuote(id, {
    //         onSuccess: (response: ServiceResponse) => {
    //             if (response.data.quote.days_count && response.data.quote.days_count > 0) {
    //                 setQuoteForm({ ...quoteForm, ['reference']: '', ['days_count']: 0 });
    //             }

    //             setQuoteForm(response.data.quote);

    //             setQuoteCheckDocument(response.data.quote.is_route_segment_document);
    //             setVerifyingQuote(false);
    //         },
    //         onError: (response: ServiceResponse) => {
    //             toast.error(response.message);
    //             navigationPage('/quotes');
                
    //         }
    //     });
    // };

    const [quoteInvoicingForm, setQuoteInvoicingForm] = useState<QuoteInvoicingShowDataForm>({
      
        });


            const reloadQuoteInvoicing = (id: number) => {
    
            if (id) {
                getQuoteInvoicingByQuote(Number(id),'view', {
                    onSuccess: (response: ServiceResponse) => {
                        setQuoteInvoicingForm(response.data.quote_invoicing);
                    },
                    onError: (response: ServiceResponse) => 
                        {
                        toast.info(response.message);
                    }
                });
            }
        };

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Cotizaciones',
            url: '/quotes',
            isActive: false
        },
        {
            name: 'Mostrar Cotización #' + id,
            url: `/quotes/${id}/show`,
            isActive: true
        }
    ];

    return (
        <>
            <Breadcrumbs pageSection={`Mostrar cotización #${id}`} breadcrumbs={breadcrumbs} />

            <Tabs defaultActiveKey="general-data" id="quote-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <QuoteTab
                        fetchingQuote={fetchingQuote}
                        quoteShowForm={quoteForm}
                        isFormShow={true}
                    />
                </Tab>
                <Tab eventKey="invoicing" title="Facturación">
                    <DefaultCard>
                        <div className="h3 mt-0 mb-2 card-title">Facturación</div>
                        {!fetchingQuoteInvoicingByQuote ? (
                            <>
                                <QuoteInvoicingShowForm
                                    quoteInvoicingForm={quoteInvoicingForm}
                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}
                    </DefaultCard>
                </Tab>
                <Tab eventKey="interlocutors" title="Interlocutores" disabled />

                <Tab eventKey="options" title="Opciones">
                    <div className="col-12">
                        <QuoteRouteSegmentsContainer
                            quoteCheckDocument={quoteCheckDocument}
                            quoteId={id}
                            quoteRouteSegments={quoteRouteSegments}
                            setQuoteRouteSegments={setQuoteRouteSegments}
                            isFormShow={true}
                        />
                    </div>
                </Tab>

                <Tab eventKey="management" title="Gestión" disabled />
            </Tabs>

            <QuoteDetailsShowContainer quoteId={id} />
        </>
    );
};

export default QuoteShowContainer;
